/* COWEET mobile product video helper.
   Based on poster pixel content, not filename or nominal aspect ratio.
   Only confidently detected pillar-boxed portraits are cropped. */
(function () {
  if (window.__coweetMobileVideoFitInit) return;
  window.__coweetMobileVideoFitInit = true;

  function looksPillarboxed(image) {
    try {
      if (image.naturalWidth < 40 || image.naturalHeight < 40) return false;
      const canvas = document.createElement('canvas');
      const w = 144, h = 81;
      canvas.width = w; canvas.height = h;
      const ctx = canvas.getContext('2d', { willReadFrequently: true });
      if (!ctx) return false;
      ctx.drawImage(image, 0, 0, w, h);
      const d = ctx.getImageData(0, 0, w, h).data;
      const brightPerCol = [];
      for (let x = 0; x < w; x++) {
        let lit = 0, checked = 0;
        for (let y = 8; y < h - 8; y += 3) {
          const p = (y * w + x) * 4;
          // Perceived lightness, with allowance for compression artifacts.
          const luma = (d[p] * 3 + d[p + 1] * 6 + d[p + 2]) / 10;
          if (luma > 32) lit++;
          checked++;
        }
        brightPerCol.push(lit / checked);
      }
      const mean = (start, end) => {
        let sum = 0;
        for (let i = start; i < end; i++) sum += brightPerCol[i];
        return sum / Math.max(1, end - start);
      };
      // Both outer sides must genuinely be dark, while the middle has
      // enough visible detail to rule out a simple fade-to-black poster.
      if (mean(0, 20) > 0.065 || mean(124, 144) > 0.065) return false;
      if (mean(56, 88) < 0.32) return false;
      let start = -1, end = -1;
      for (let x = 0; x < w; x++) {
        const nearby = mean(Math.max(0, x - 2), Math.min(w, x + 3));
        if (nearby > 0.19) { if (start === -1) start = x; end = x; }
      }
      if (start === -1) return false;
      const contentWidth = (end - start + 1) / w;
      const approximatelyCentered = Math.abs((start + end) / 2 - w / 2) < w * 0.13;
      return start / w > 0.17 && end / w < 0.83 &&
        contentWidth > 0.22 && contentWidth < 0.68 &&
        approximatelyCentered;
    } catch (e) {
      // Cross-origin or unavailable posters are left unmodified.
      return false;
    }
  }

  function enhance(box) {
    if (box.dataset.coweetVideoChecked === 'true') return;
    box.dataset.coweetVideoChecked = 'true';
    const video = box.querySelector('.product__media video');
    if (video) {
      const orientation = () => {
        if (video.videoWidth > 0 && video.videoHeight > 0) {
          box.dataset.coweetVideoOrientation =
            video.videoHeight > video.videoWidth * 1.12 ? 'portrait' : 'landscape';
        }
      };
      video.addEventListener('loadedmetadata', orientation, { once: true });
      orientation();
    }
    const poster = (video && video.getAttribute('poster')) ||
      (box.querySelector('.deferred-media__poster img') || {}).src ||
      (box.querySelector('.product__media img') || {}).src;
    if (!poster) return;
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = function () {
      if (looksPillarboxed(image)) {
        box.classList.add('coweet-video--pillarboxed');
        box.dataset.coweetVideoOrientation = 'portrait-in-landscape';
      }
    };
    image.onerror = function () {};
    image.src = poster;
    if (image.complete && image.naturalWidth) image.onload();
  }
  function scan(root) {
    const selector = 'media-gallery .product__media-list .product-media-container.media-type-video, ' +
      'media-gallery .product__media-list .product-media-container.media-type-external_video';
    if (root.matches && root.matches(selector)) enhance(root);
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach(enhance);
  }
  function init() { scan(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else { init(); }
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();
